import __request__ from "routing/request";
export function upload(file, requestOptions) {
  const formData = new FormData();
  formData.append("file", file);
  return __request__("POST", "/plugins/org.graylog.plugins.lookup/data_adapters/csv_files", formData, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function config(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.lookup/data_adapters/csv_files/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function download(fileId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.lookup/data_adapters/csv_files/${fileId}`, null, {}, {
    "Accept": []
  }, requestOptions);
}
export function metadata(fileId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.lookup/data_adapters/csv_files/${fileId}/metadata`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
